import cn from 'classnames';
import { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import styles from './PartnerTeethMissing.module.scss';

type Props = {
  className?: string;
};

// A partner template's line that prints, by a value or by the template's
// default, while its teeth picker is empty: in the partner's text it reads as
// done on no tooth. It only warns; the note can still be saved.
export const PartnerTeethMissing: FC<Props> = ({ className }) => {
  const { formatMessage } = useIntl();

  return (
    <span
      className={cn('p2', styles.warning, className)}
      title={formatMessage({
        id: 'workspace.note.partnerTeethMissingHint',
        defaultMessage:
          'Choose the tooth, or skip the line if it does not apply',
      })}
      data-component="workspace-note-partner-teeth-missing"
    >
      <FormattedMessage
        id="workspace.note.partnerTeethMissing"
        defaultMessage="printed without a tooth"
      />
    </span>
  );
};
